import { render, staticRenderFns } from "./EstablishmentViewTransfersAddTransferModal.vue?vue&type=template&id=11d815ea"
import script from "./EstablishmentViewTransfersAddTransferModal.vue?vue&type=script&lang=js"
export * from "./EstablishmentViewTransfersAddTransferModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports